import { enumRecordToCheckboxOptions } from '../helpers';

export enum PayPeriodEnum {
  WEEKLY = 'Weekly',
  BIWEEKLY = 'Biweekly',
  TWICEMONTHLY = 'TwiceMonthly',
  MONTHLY = 'Monthly',
  CUSTOM = 'Custom'
}

export const PAY_PERIOD_ENUM_RECORD: Record<PayPeriodEnum, string> = {
  [PayPeriodEnum.WEEKLY]: 'Weekly',
  [PayPeriodEnum.BIWEEKLY]: 'Biweekly',
  [PayPeriodEnum.TWICEMONTHLY]: 'Twice a month',
  [PayPeriodEnum.MONTHLY]: 'Monthly',
  [PayPeriodEnum.CUSTOM]: 'Custom'
};

export const PAY_PERIOD_OPTIONS = enumRecordToCheckboxOptions(
  PAY_PERIOD_ENUM_RECORD
);
